import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { makeStyles, withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import { Icon } from 'react-icons-kit'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import { blocked } from 'react-icons-kit/icomoon/blocked'
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit'
import { folderPlus } from 'react-icons-kit/icomoon/folderPlus'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { ic_attach_money } from 'react-icons-kit/md/ic_attach_money'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Swal from 'sweetalert2'
import { qrcode } from 'react-icons-kit/icomoon/qrcode'
import Checkbox from '@material-ui/core/Checkbox';
import withReactContent from 'sweetalert2-react-content'
import TableDetail from '../TableDetail'
import api from '../../services/api'
import Tooltip from '@material-ui/core/Tooltip';
import { colors } from '../../utils/vars'
import { mCPF, mCNPJ, mVAL } from '../../utils/masks'
import { ic_fiber_manual_record } from 'react-icons-kit/md/ic_fiber_manual_record'
import { fileText } from 'react-icons-kit/icomoon/fileText'
import { ic_history } from 'react-icons-kit/md/ic_history'
import Dialog from '@material-ui/core/Dialog';
import FrTextInput from '../FrTextInput'
import { userTie } from 'react-icons-kit/icomoon/userTie'
import './index.css';
import { calculoMultaJuros, getUserCode } from '../../utils/functions';
import { creditCard } from 'react-icons-kit/icomoon/creditCard'
import { coinDollar } from 'react-icons-kit/icomoon/coinDollar'
import FrSelect from '../FrSelect'
import FrDatePicker from '../FrDatePicker'
import { spinner11 } from 'react-icons-kit/icomoon/spinner11'
import { vcard } from 'react-icons-kit/fa/vcard'
import { MDBContainer, MDBIframe } from "mdbreact";
import FrLoading from '../FrLoading'
import { externalLink } from 'react-icons-kit/fa/externalLink'
import { ic_picture_as_pdf } from 'react-icons-kit/md/ic_picture_as_pdf'
import { ic_email } from 'react-icons-kit/md/ic_email'
import { eye } from 'react-icons-kit/icomoon/eye'
import { exchange } from 'react-icons-kit/fa/exchange'
import { ic_search } from 'react-icons-kit/md/ic_search'
import AutoComp from '../AutoComp'
import Clientes from '../../pages/Clientes'
const moment = require("moment");

const swal = withReactContent(Swal)

const theme = createTheme({
  palette: {
    primary: { main: '#083c7c' },
  },
}, ptBR);

const FrCheckBox = withStyles({
  root: {
    // padding: '1px',
    color: 'var(--cor-fonte-hover)',
    '&$checked': {
      color: 'var(--cor-fonte-hover)',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


const useStyles = makeStyles(theme => ({
  root: {
    color: 'var(--cor-fonte-hover)',
    backgroundColor: 'var(--cor-tabela)',
    transitionDuration: "0.4s",
    "& .Mui-selected": {
      backgroundColor: 'var(--cor-tabela-selected)',
      transitionDuration: "0.4s",

    },

    "& .Mui-selected:hover": {
      backgroundColor: 'var(--cor-tabela-selected-hover)',
      transitionDuration: "0.4s",

    },
    "& .MuiTableCell-body": {
      color: 'var(--cor-fonte-hover)',
    },
    "&.Mui-active": {
      color: 'var(--cor-tabela)',
    },

    width: '100%',
    hover: {
      transitionDuration: "0.4s",
      color: 'yellow',
    }
  },


  row: {
    padding: '1px',
    // backgroundColor: 'rgba(133, 130, 130, 0.9)',
  },

  container: {
    borderRadius: '4px',
    maxHeight: ({ frame, relacionados }) => relacionados ? 'none' : (frame ? '40vh' : '58vh'),
    minHeight: ({ frame, relacionados }) => relacionados ? 'none' : (frame ? '40vh' : '58vh'),
  },
  containerDense: {
    maxHeight: "25vh",
    minHeight: "25vh",
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  try {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);

  } catch (error) {

  }
}



const StyledTableCell = withStyles((theme) => ({

  head: {
    backgroundColor: '#083c7c',
    color: 'var(--cor-fonte)',
    transitionDuration: "0.4s",

  },
  body: {
    backgroundColor: 'var(--cor-tabela)',
    color: 'var(--cor-fonte)',
    transitionDuration: "0.4s",
    fontSize: 25,
  },
}))(TableCell);

const StyledTableSortLabel = withStyles((theme) =>
({
  root: {
    color: 'white',
    "&:hover": {
      color: 'yellow !important',
    },
    '&$active': {
      color: 'yellow !important',
    },
  },
  active: {},
  icon: {
    color: 'inherit !important'
  },
})
)(TableSortLabel);

export default function FrTable(props) {
  const classes = useStyles({ frame: props.frame, relacionados: props.relacionados });
  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(props.frame ? 25 : props.rowsPerPage ? props.rowsPerPage : 10);
  const [data, setData] = useState(props.data)
  const [columns, setColumns] = useState(props.columns)
  const [order, setOrder] = React.useState(props.startOrder || 'asc');
  const [orderBy, setOrderBy] = React.useState(props.startOrderBy || props.columns[0].id);
  const [selected, setSelected] = React.useState([]);
  const [opened, setOpened] = React.useState([]);
  const [width, setWidth] = React.useState(props.width || 100);
  const [showModal, setShowModal] = React.useState(false);
  const [showModalFaturamento, setShowModalFaturamento] = React.useState(false);
  const [dataHis, setDataHis] = useState('')
  const [dataCtr, setDataCtr] = useState('')
  const [titulo, setTitulo] = useState('')
  const [incluiHis, setIncluiHis] = React.useState(false);
  const [historico, setHistorico] = useState('')
  const [codigo, setCodigo] = useState('')
  const [fk_cto, setFk_Cto] = useState('')
  const [comboCto, setComboCto] = useState([{ value: '', display: '' }])
  const [fk_tso, setFk_Tso] = useState('')
  const [comboTso, setComboTso] = useState([{ value: '', display: '' }])
  const [fk_thi, setFk_Thi] = useState('')
  const [comboThi, setComboThi] = useState([{ value: '', display: '' }])
  const [fk_shi, setFk_Shi] = useState('')
  const [comboShi, setComboShi] = useState([{ value: '', display: '' }])
  const [data_retorno, setData_Retorno] = useState('')
  const [ctoVigente, setCtoVigente] = useState('')
  const [cliente, setCliente] = useState('')
  const [showModalCartoes, setShowModalCartoes] = React.useState(false);
  const [dataDep, setDataDep] = useState([{ value: '', display: '' }])
  const [arquivoCartoes, setArquivoCartoes] = useState('')
  const [arquivoFaturamento, setArquivoFaturamento] = useState('')
  const [showModalTroca, setShowModalTroca] = useState('')
  const [dadosCtoTroca, setDadosCtoTroca] = useState({})
  const [novoTitularCto, setNovoTitularCto] = useState(null)
  const [showModalCliente, setShowModalCliente] = useState(false)
  const [showModalNovosValores, setShowModalNovosValores] = useState(false)
  const [comboCli, setComboCli] = useState([])
  const [nomeCli, setNomeCli] = useState()
  const [showValoresCaixa, setShowValoresCaixa] = useState()
  const [valoresCaixa, setValoresCaixa] = useState()
  const [total, setTotal] = useState()
  const [cta, setCta] = useState()

  const columnsHis = [
    { id: 'format_data', numeric: false, label: 'Data', align: 'left', minWidth: 50 },
    { id: 'nomeusu', numeric: false, label: 'Usuário', align: 'left', minWidth: 50 },
    { id: 'descricao', numeric: false, label: 'Histórico', align: 'left', minWidth: 200 },
    { id: 'fk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
  ]

  const columnsValores = [
    { id: 'conta', numeric: false, label: 'Conta', align: 'left', minWidth: 50 },
    { id: 'plano_conta', numeric: false, label: 'Plano de Conta', align: 'left', minWidth: 50 },
    { id: 'sinal', numeric: false, label: 'Sinal', align: 'left', minWidth: 200 },
    { id: 'forma_pagamento', numeric: false, label: 'Forma de Pagamento', align: 'left', minWidth: 50 },
    { id: 'valor', numeric: false, label: 'Valor', align: 'left', minWidth: 50 },
    { id: 'ordem_relatorio', numeric: false, label: 'Ordem Relatório', align: 'left', minWidth: 50 },
  ]

  const columnsCtr = [{ id: 'parcela', numeric: false, label: 'Parcela', align: 'center', minWidth: 50 },
  { id: 'data_venc', date: true, numeric: false, label: 'Vencimento', align: 'left', minWidth: 100 },
  { id: 'valor', moeda: true, numeric: false, label: 'Valor', align: 'left', minWidth: 200 },
  { id: 'promocao', numeric: false, label: 'Promoção', align: 'left', minWidth: 200 },
  { id: 'justificativa_promocao', numeric: false, label: 'Justificativa Promo', align: 'left', minWidth: 200 },
  ]

  const columnsDep = [
    { id: 'nome', numeric: false, label: 'Nome', align: 'left', minWidth: 50 },
  ]

  useEffect(() => {
    const fetchRep = async () => {

      if (novoTitularCto > 0) {
        await api.get("/clientes?pk_cli=" + novoTitularCto).then((r) => {
          if (r.data[0]) {
            setNomeCli(r.data[0].nome);

          }
        });
      }

    };
    fetchRep();
  }, [novoTitularCto]);

  function copiarParaAreaDeTransferencia(texto) {
    // Cria um elemento de texto temporário
    const elementoTemporario = document.createElement('textarea');
    elementoTemporario.value = texto;
    document.body.appendChild(elementoTemporario);

    // Seleciona o texto no elemento temporário
    elementoTemporario.select();
    elementoTemporario.setSelectionRange(0, 99999); // Para dispositivos móveis

    // Copia o texto para a área de transferência
    document.execCommand('copy');

    // Remove o elemento temporário
    document.body.removeChild(elementoTemporario);

    // Mensagem de confirmação (opcional)
    swal.fire({
      title: '',//`<h2 style='color:${colors.info900}'>Registro Excluído</h2>`,
      html: <p style={{ color: colors.info900 }}>Link copiado para a área de transferência!</p>,
      icon: 'success',
    })
  }

  const calculaMensalidade = async () => {
    if (dadosCtoTroca.fk_tco > 0) {
      const auxValues = { ...dadosCtoTroca };
      auxValues.usu_logado = getUserCode();
      // auxValues.mensalidade = 0
      await api.get('/tipo_contrato?pk_tco=' + dadosCtoTroca.fk_tco).then(async r => {
        if (r.data[0]) {
          // setComboFpg(await api.getComboDataWhere('formas_pagamento', "?fk_tpf=" + r.data[0].fk_tpf))
          auxValues.fk_tpf = r.data[0].fk_tpf
        }
      })

      const deps = dataDep.filter(item => {
        return (item.data_cancelado == null && item.nome != '' && item.fk_cli_dep != novoTitularCto)
      })

      await api.get('/tabela_precos?fk_tco=' + auxValues.fk_tco + '&qtd_deps=' + deps.length).then(r => {
        if (r.data[0]) {
          auxValues.mensalidade = mVAL(r.data[0].valor * 100)
          let valorFinal = Number(r.data[0].valor)
          // console.log(r.data[0])

          let desconto = 0

          if (r.data[0].desconto_cliente > 0)
            desconto = Number(r.data[0].desconto_cliente)

          if (r.data[0].desconto_sede > 0)
            desconto = desconto + Number(r.data[0].desconto_sede)

          if (r.data[0].desconto_outros > 0)
            desconto = desconto + Number(r.data[0].desconto_outros)



          valorFinal = Math.round(valorFinal * ((100 - desconto)))


          auxValues.valor_final = mVAL(valorFinal)
          console.log(auxValues)

          setDadosCtoTroca(auxValues)
        } else
          setDadosCtoTroca(auxValues)
      })
    }
  }

  function copiaLink(e, link) {
    e.preventDefault()
    // Exemplo de uso
    copiarParaAreaDeTransferencia(props.link + link);
  }

  function cancelarContrato(e, pk_cto) {
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      title: 'ATENÇÃO',
      text: "Confirma geração do contrato?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      console.log(result)
      if (result.value) {
        swal.fire({
          html: <FrLoading text="Cancelando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })

        api.post('contratos/cancelamento', { selected: [pk_cto] }).then(res => {
          swal.fire('Sucesso!', 'Contrato cancelado', 'success')
        })
      }
    })
  }

  function imprimeCartoes(e, id) {
    e.preventDefault()
    setTitulo('Impressão de Cartões Contrato Nº ' + id)
    api.get('/contratos/dependentes?pk_cto=' + id).then(r => {
      if (r.data.length > 0) {
        setDataDep(r.data)
        setShowModalCartoes(true)
      } else {
        swal.fire({
          title: `<h2 style='color:${colors.info900}'>Atenção</h2>`,
          html: <p style={{ color: colors.info900 }}>Contrato sem dependentes!</p>,
          icon: 'warning',
        })

      }
    })
  }

  function imprimeFatura(pk_cte) {
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/faturamento_empresa/relatorio?pk_fat=' + pk_cte, { responseType: 'blob' }).then(r => {
      swal.close()
      let data = URL.createObjectURL(r.data)
      setShowModalFaturamento(true)
      setArquivoFaturamento(data)
    })
  }
  async function confirmaProcessoTroca(atualizaValor) {
    swal.fire('Confirma a troca de titular?', `Substituir responsável ${dadosCtoTroca.nomecli} por ${nomeCli} ?`, 'question').then(response => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.post('contratos/troca_titular', { ...dadosCtoTroca, novoCli: novoTitularCto, atualizaValor: atualizaValor }).then(r => {
        swal.close()
      })
    })
  }
  async function confirmaModalTroca(e) {
    // e.preventDefault()
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    await api.get('/contratos/dependentes?pk_cto=' + dadosCtoTroca.pk_cto).then(r => {
      console.log(r.data)
      if (r.data.length > 0) {
        setDataDep(r.data)
      }
    })
    calculaMensalidade()
    api.get('dependentes?fk_cli_dep=' + novoTitularCto).then(r => {
      console.log(novoTitularCto)
      if (r.data[0] && r.data[0].pk_dep) {
        swal.fire('Novo responsável selecionado é dependente', 'Deseja exclui-lo dos dependentes e prosseguir?', 'question').then(response => {
          mostraModalNovosValores()
        })
      } else {
        confirmaProcessoTroca(false)
      }
      // escondeModalTroca()
      // swal.close()
    })
  }

  async function mostraModalNovosValores() {
    setShowModalTroca(false)
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    let auxValues = []
    api.get('contas_receber?pk_cto=' + dadosCtoTroca.pk_cto + '&situacao=and coalesce(ctr.valor_baixado,0)=0').then(r => {
      console.log(r.data)
      if (r.data) {
        r.data.forEach((item, index) => {
          auxValues.push({
            ...item,
            valor: dadosCtoTroca.valor_final
          })
          if (index == r.data.length - 1) {
            setDataCtr(auxValues)
            console.log(auxValues)
            swal.close()
            setShowModalNovosValores(true)
          }
        })
      }
    })

  }

  function mostraModalCliente(e) {
    e.preventDefault()
    setShowModalCliente(true)
  }

  async function trocaTitularContrato(cto) {
    console.log(cto)
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    setComboCli(await api.getComboData('clientes'))
    setShowModalTroca(true)
    setDadosCtoTroca(cto)
    swal.close()
  }

  function geraNota(row) {
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>Nota não gerada</h2>`,
      html: <p style={{ color: colors.info900 }}>{'Deseja gerar e enviar?'}</p>,
      showConfirmButton: true,
      showCancelButton: true,
      allowOutsideClick: true,
      allowEscapeKey: false,
    }).then(r => {
      console.log(r)
      if (r.value) {
        api.post('/faturamento_empresa/gera_nota', { total: row['total'], fk_ctr: row['fk_ctr'] }).then(r => {
          return swal.fire(r.data.titulo, r.data.mensagem, r.data.status)
        })
      }
    })
  }

  function baixaNtf(pk_cte, row) {
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    api.get('/faturamento_empresa/baixa_ntf?pk_fat=' + pk_cte,).then(r => {
      console.log(r)
      if (r.data.type == 'question') {
        return geraNota(row)
      }
      if (r.data.message) {
        return swal.fire('Erro', r.data.message, r.data.type)
      }
      swal.close()
      let data = URL.createObjectURL(r.data)
      setShowModalFaturamento(true)
      setArquivoFaturamento(data)
    }).catch(e => {
      swal.fire('Erro', 'Falha na requisição, tente novamente.', 'error')
    })
  }

  function enviaFatura(pk_fat, row) {
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    api.get('/faturamento_empresa/envia_email?pk_fat=' + pk_fat).then(r => {
      if (r.data.type == 'question') {
        return geraNota(row)
      }

      swal.fire('Sucesso!', r.data.message, r.data.type)
    })
  }

  function cancelaFatura(pk_cte) {
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Confirma cancelamento da fatura?</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result) {
        swal.fire({
          html: <FrLoading text="Carregando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        api.get('/faturamento_empresa/cancela_fatura?pk_fat=' + pk_cte + '&fk_usu=' + getUserCode()).then(r => {
          console.log(r.data)
          if (r.data == 'done') {
            swal.fire('Sucesso!', 'Fatura cancelada.', 'success')
          }
        })

      }
    })
  }

  function buscaValoresCaixa(fk_cta) {
    console.log('buscando bvalores')
    setCta(fk_cta)
    api.post('controle_caixa/buscaValores', { fk_cta: fk_cta }).then(r => {
      console.log(r.data)
      setValoresCaixa(r.data)
      setShowValoresCaixa(true)
      let sum = r.data.reduce((accumulator, currentValue) => {
        let i = currentValue.sinal//*currentValue.v
        console.log(i)
        return accumulator + (Math.round((i) * 100) / 100)
      }, 0)

      console.log(sum)
      setTotal(Math.round(sum * 100) / 100)
    })
  }

  function fechaCaixa() {
    setShowValoresCaixa(false)
    api.post('controle_caixa/fechar', { fk_cta: cta, total: total })
  }

  function renovaContrato(e, cto) {
    e.preventDefault()
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Confirma renovar o contrato selecionado?</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {

        api.post('/contratos/renovar?pk_cto=' + cto).then(r => {
          if ((r.status === 200) && (r.data.substr(0, 5) !== 'Erro!')) {
            if (r.data == 'Já gerou!')
              swal.fire({
                title: `<h2 style='color:${colors.info900}'>Atenção</h2>`,
                html: <p style={{ color: colors.info900 }}>Contrato já foi renovado!</p>,
                icon: 'warning',
              })

            else
              swal.fire({
                title: `<h2 style='color:${colors.info900}'>Contrato Renovado</h2>`,
                html: <p style={{ color: colors.info900 }}>Contrato renovado com sucesso!</p>,
                icon: 'success',
              }).then((result) => {
                if (result.value) {
                  window.location.reload()
                }
              })
          }
        })
      }
    })
  }

  useEffect(() => {
    try {
      setData(props.data)
      setPage(0)
      if (props.firstSel) setSelected(props.firstSel)
    } catch (error) {

    }

  }, [props.data])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    try {
      if (props.onChangeCheckbox) props.onChangeCheckbox(selected)
    } catch (error) {

    }

  }, [selected])

  const deleteRecord = (e, id, table) => {
    e.preventDefault()
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja excluir PERMANENTEMENTE o registro selecionado?</p>`,
      // text: "Deseja excluir PERMANENTEMENTE o registro selecionado?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        api.post('/' + table + '/delete/' + id).then(r => {
          if ((r.status === 200) && (r.data.substr(0, 5) !== 'Erro!')) {
            swal.fire({

              title: `<h2 style='color:${colors.info900}'>Registro Excluído</h2>`,
              html: <p style={{ color: colors.info900 }}>O registro foi excluído com sucesso!</p>,
              icon: 'success',
            }).then((result) => {
              if (result.value) {
                window.location.reload()
              }
            })
          } else {
            swal.fire({
              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              text: "O registro não foi excluído! " + r.data,
              icon: 'warning',
            })
          }
        }).catch(e => {
          //console.log(e.response.data)
          if (e.response?.data?.sqlMessage && e.response?.data?.sqlMessage.indexOf('Cannot delete or update a parent row: a foreign key constraint fails') >= 0) {
            swal.fire({
              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              text: "O registro não foi excluído pois possui outros registros vinculados! ",
              icon: 'warning',
            })
          } else {
            swal.fire({
              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              text: "Houve um problema na exclusão do registro!",
              icon: 'warning',
            })
          }
        })
      }
    })
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n[props.codeName]);
      setSelected(newSelecteds);
      if (props.setSelected)
        props.setSelected(newSelecteds)

      return;
    }
    setSelected([]);
    if (props.setSelected)
      props.setSelected([])

  };

  function handleClickMensalidade(event, name, row) {

    let auxValues = new Set(selected)
    let auxTotal = props.totalParcelas

    if (auxValues.has(name)) {
      auxValues.delete(name)
      auxTotal -= calculoMultaJuros(name, row)
    } else {
      auxValues.add(name)
      auxTotal += calculoMultaJuros(name, row)
    }

    setSelected(auxValues)
    props.setSelected && props.setSelected()
    props.setTotalParcelas && props.setTotalParcelas(auxTotal)

  }

  const handleClick = (event, name, row) => {
    if (props.regName == 'mensalidades') {
      return handleClickMensalidade(event, name, row)
    }
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
    if (props.setSelected)
      props.setSelected(newSelected)
  };

  const handleClickModal = (event, name, codigo) => {
    //console.log('dbclick', codigo, name)
    if (props.setNomeCli)
      props.setNomeCli(name)
    if (props.setPk_Cli)
      props.setPk_Cli(codigo)
    if (props.setPk_lan)
      props.setPk_lan(codigo)

    if (props.setShowModal)
      props.setShowModal(false)
  };


  const handleClickDetail = (event, name) => {
    const selectedIndex = opened.indexOf(name);
    let newOpened = [];

    if (selectedIndex === -1) {
      newOpened = newOpened.concat(opened, name);
    } else if (selectedIndex === 0) {
      newOpened = newOpened.concat(opened.slice(1));
    } else if (selectedIndex === opened.length - 1) {
      newOpened = newOpened.concat(opened.slice(0, -1));
    } else if (selectedIndex > 0) {
      newOpened = newOpened.concat(
        opened.slice(0, selectedIndex),
        opened.slice(selectedIndex + 1),
      );
    }

    setOpened(newOpened);
  }


  const isSelected = (name) => selected.indexOf(name) !== -1;

  const isOpened = (name) => opened.indexOf(name) !== -1;



  function chamaRegistro(e, regName, id) {
    e.preventDefault()
    //console.log(props.modal)
    if (!props.modal) {

      window.location.href = "/salute/" + regName + "/registro?codigo=" + id
    }
    else {
      props.setShowModal(true)
      props.setPk_lan && props.setPk_lan(id)
    }


  }



  function handleDelete(e, id, table) {
    e.preventDefault()
    let comando = '/' + table + '/delete/' + id
    if ((table.toLowerCase() == 'clientes') || (table.toLowerCase() == 'contratos'))
      comando = '/' + table + '/delete?id=' + id + '&fk_usu=' + getUserCode()

    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja excluir PERMANENTEMENTE o registro selecionado?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {

        api.post(comando).then(r => {
          // console.log(r.data)
          if ((r.status === 200) && (r.data.substr(0, 5) !== 'Erro!')) {
            swal.fire({
              title: 'Registro Excluído',
              text: "O registro foi excluído com sucesso!",
              icon: 'success',
            }).then((result) => {
              if (result.value) {
                window.location.reload()
              }
            })
          } else {
            swal.fire({
              title: 'Erro!',
              text: "O registro não foi excluído! " + r.data.substr(6, r.data.length),
              icon: 'warning',
            })
          }
        })
      }
    })
  }

  function debitoConta(e, id) {
    e.preventDefault()
    window.open(api.backendUrl + '/static/upload/' + id + '/debito_conta.txt', '_blank');
  }

  function boleto(e, id) {
    e.preventDefault()
    window.open(api.backendUrl + '/static/upload/' + id + '/boleto.txt', '_blank');
  }


  function mostraHistorico(e, id, table, nomecli, ctoVigente, pk_cli) {
    e.preventDefault()
    let where = ''
    setCodigo(id)
    setCtoVigente(ctoVigente)
    setCliente(pk_cli)
    if (table == 'clientes') {
      where = 'fk_cli=' + id
      setTitulo('Históricos do cliente cód.:' + id + ' - ' + nomecli)
    } else {
      where = 'fk_cto=' + id
      setTitulo('Históricos do contrato cód.:' + id)
    }

    api.get('/historicos?' + where).then(r => {
      if (r.data[0]) {
        setDataHis(r.data)
        setShowModal(true)
      } else {
        setDataHis([{ value: '', display: '' }])
        setShowModal(true)
      }
    })
  }

  function confirmaImprimeCartoes(e) {
    e.preventDefault()
    // alert(selected)
    api.get('/contratos/imprimeCartoes?id=' + selected, { responseType: 'blob' }).then(r => {
      let data = URL.createObjectURL(r.data)
      setArquivoCartoes(data)
    })
  }

  function escondeModal(e) {
    e.preventDefault()
    setShowModal(false)
    setIncluiHis(false)
    setShowModalCartoes(false)
    setArquivoCartoes('')
  }

  function escondeModalTroca(e) {
    e.preventDefault()
    setShowModalTroca(false)
    setDadosCtoTroca({})
    setNovoTitularCto(null)
    setShowModalCliente(false)
  }

  async function incluirHis(e) {
    e.preventDefault()
    setHistorico('')
    setFk_Cto(ctoVigente)
    setFk_Thi('')
    setFk_Shi('')
    setFk_Tso('')
    setData_Retorno('')

    if (props.regName == 'contratos')
      setComboCto(await api.getComboDataWhere('contratos', "?fk_cli=" + cliente))
    else
      setComboCto(await api.getComboDataWhere('contratos', "?fk_cli=" + codigo))

    setComboShi(await api.getComboData('situacao_historico'))
    setComboThi(await api.getComboData('tipo_historico'))
    setComboTso(await api.getComboData('tipo_solicitacao'))


    setIncluiHis(true)
  }

  function confirmaHis(e) {
    e.preventDefault()
    const auxValues = { ...data };
    auxValues.fk_usu = getUserCode()
    auxValues.descricao = historico
    auxValues.fk_cto = fk_cto
    auxValues.fk_thi = fk_thi
    auxValues.fk_shi = fk_shi
    auxValues.fk_tso = fk_tso
    auxValues.data_retorno = data_retorno
    if (props.regName == 'clientes') {
      auxValues.fk_cli = codigo
      // auxValues.fk_cto = null
    } else {
      auxValues.fk_cli = null
      auxValues.fk_cto = codigo
    }
    api.post('/historicos/add', auxValues).then(r => {
      if (r.status === 200) {
        let where = ''
        if (props.regName == 'clientes') {
          where = 'fk_cli=' + codigo
        } else {
          where = 'fk_cto=' + codigo
        }

        api.get('/historicos?' + where).then(r => {
          if (r.data[0]) {
            setDataHis(r.data)
          } else {
            setDataHis([{ value: '', display: '' }])
          }
        })

        setIncluiHis(false)
      }
    })
  }

  const handleChange = (e) => {
    if (e.target.name == 'fk_cto')
      setFk_Cto(e.target.value)
    else
      if (e.target.name == 'fk_tso')
        setFk_Tso(e.target.value)
      else
        if (e.target.name == 'historico')
          setHistorico(e.target.value)
        else
          if (e.target.name == 'fk_shi')
            setFk_Shi(e.target.value)
          else
            if (e.target.name == 'data_retorno')
              setData_Retorno(e.target.value)
            else
              if (e.target.name == 'fk_thi')
                setFk_Thi(e.target.value)

  };

  const handleChangeTableInput = (e, index, pk) => {
    e.preventDefault();
    let auxValues = [...data]
    let row = auxValues.find(item => item[props.codeName] === pk)
    let rest = auxValues.filter(item => item[props.codeName] !== pk)

    row[e.target.name] = e.target.value

    props.setData([...rest, row])
  }

  return (
    <ThemeProvider theme={theme}>
      <div >
        <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'}>
          <div className="defaultHeader">
            <h3>{titulo}</h3>
          </div>
          <div className="modalContent">
            <FrSelect
              value={fk_cto || ''}
              onChange={handleChange}
              name="fk_cto"
              id="fk_cto"
              label='Contrato'
              data={comboCto}
              style={{ width: 90 }}
              hidden={!incluiHis}
            />
            <FrSelect
              value={fk_thi || ''}
              onChange={handleChange}
              name="fk_thi"
              id="fk_thi"
              label='Tipo Atendimento'
              data={comboThi}
              style={{ width: 200 }}
              hidden={!incluiHis}
            />

            <FrSelect
              value={fk_tso || ''}
              onChange={handleChange}
              name="fk_tso"
              id="fk_tso"
              label='Tipo Solicitação'
              data={comboTso}
              style={{ width: 300 }}
              hidden={!incluiHis}
            />
            <br />
            <FrTextInput
              maxLength='500'
              value={historico || ''}
              onChange={handleChange}
              name='historico'
              id='historico'
              color='#528b46'
              label='Histórico'
              variant="filled"
              size='small'
              required
              style={{ padding: '5px' }}
              multiline
              rows="8"
              rowsMax="8"
              fullWidth
              hidden={!incluiHis}
              autoFocus
            />
            <br />

            <FrSelect
              value={fk_shi || ''}
              onChange={handleChange}
              name="fk_shi"
              id="fk_shi"
              label='Situação Histórico'
              data={comboShi}
              style={{ width: 200 }}
              hidden={!incluiHis}
            />

            <FrDatePicker
              value={(data_retorno || '').split('T')[0]}
              name="data_retorno"
              id="data_retorno"
              color="#49573B"
              label="Data Retorno"
              variant="outlined"
              size="small"
              style={{ width: 190 }}
              onChange={handleChange}
              hidden={!incluiHis}
            />

            <div hidden={incluiHis} className="tableDiv">
              <FrTable startOrder='desc' startOrderBy='data' columns={columnsHis} data={dataHis} readOnly={true} />
            </div>

            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">

                <button hidden={incluiHis} onClick={incluirHis}> Incluir</button>
                <button hidden={!incluiHis} onClick={confirmaHis}> Confirmar</button>

                <button onClick={escondeModal}> Sair </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
      <div >
        <Dialog aria-labelledby="simple-dialog-title" open={showModalTroca} fullWidth={true} maxWidth={'lg'}>
          <div className="defaultHeader">
            <h3>{`Troca de titular contrato nº ${dadosCtoTroca.pk_cto}`}</h3>
          </div>
          <div className="modalContent">

            <FrTextInput
              maxLength='500'
              value={dadosCtoTroca.cpf || ''}
              onChange={handleChange}
              name='cpfOriginal'
              id='cpfOriginal'
              color='#528b46'
              label='CPF'
              variant="filled"
              size='small'
              style={{ padding: '5px' }}
              disabled
              autoFocus
            />
            <FrTextInput
              maxLength='500'
              value={dadosCtoTroca.nomecli || ''}
              onChange={handleChange}
              name='nomecli'
              id='nomecli'
              color='#528b46'
              label='Nome'
              variant="filled"
              size='small'
              style={{ padding: '5px' }}
              disabled
              autoFocus
            />
            <br />
            <AutoComp
              value={dadosCtoTroca.novocli || ""}
              valor={novoTitularCto}
              width={425}
              name="novocli"
              id="novocli"
              label='Novo Titular'
              data={comboCli}
              setValue={setNovoTitularCto}
              tabela={'clientes'}
              chave={'nome'}
            />
            <button className="buttonF2" style={{ height: '30px', width: '35px', borderRadius: '4px' }} onClick={mostraModalCliente}>
              <Icon icon={ic_search} size={20} />
            </button>




            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">

                <button onClick={confirmaModalTroca}> Confirmar</button>

                <button onClick={escondeModalTroca}> Sair </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>

      <div >
        <Dialog aria-labelledby="simple-dialog-title" open={showValoresCaixa} fullWidth={true} maxWidth={'lg'}>
          <div className="defaultHeader">
            <h3>{`Movimentações Caixa`}</h3>
          </div>
          <div className="modalContent">

            <div className="tableDiv">
              <FrTable startOrder='desc' startOrderBy='data' columns={columnsValores} data={valoresCaixa} readOnly={true} />
            </div>

            {`R$ ${mVAL(total)}`}

            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">

                <button onClick={fechaCaixa}> Confirmar</button>

                <button onClick={() => setShowValoresCaixa(false)}> Cancelar </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>

      <div >
        <Dialog aria-labelledby="simple-dialog-title" open={showModalNovosValores} fullWidth={true} maxWidth={'lg'}>
          <div className="defaultHeader">
            <h3>{`Troca de titular contrato nº ${dadosCtoTroca.pk_cto}`}</h3>
          </div>
          <div className="modalContent">
            <h3>
              Novos Valores
            </h3>
            <div hidden={!showModalNovosValores} className="tableDiv">
              <FrTable startOrder='desc' startOrderBy='data' columns={columnsCtr} data={dataCtr} readOnly={true} />
            </div>

            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">

                <button onClick={() => confirmaProcessoTroca(true)}> Confirmar</button>

                <button onClick={() => { setShowModalTroca(true); setShowModalNovosValores(false) }}> Voltar </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>

      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalCartoes} fullWidth maxWidth={'lg'}>
          <div className="defaultHeader">
            <h3>{titulo}</h3>
          </div>
          <div className="modalContent">

            <div className="ModalFooter">
              <div className="FrModalButtonsDiv">

                <button onClick={confirmaImprimeCartoes}> Imprimir</button>

                <button onClick={escondeModal}> Sair </button>
              </div>
            </div>
            <div hidden={arquivoCartoes} className="tableDiv">
              <FrTable setSelected={setSelected} codeName={'pk_dep'} columns={columnsDep} regName={'printCartoes'} mostraCheck={'S'} data={dataDep} readOnly={true} />
            </div>

            <div hidden={!arquivoCartoes} className='mdbContainer'>
              <MDBContainer >
                <MDBIframe src={arquivoCartoes} />
              </MDBContainer>
            </div>

          </div>
        </Dialog>
      </div>
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalCliente} fullWidth={true} maxWidth={'lg'}>
          <Clientes modal setShowModalCliente={setShowModalCliente} setNomeCli={setNomeCli} setPk_Cli={setNovoTitularCto} />
        </Dialog>
      </div>
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalFaturamento} fullWidth maxWidth={'lg'}>
          <div className="modalContent">
            <div hidden={!arquivoFaturamento} className='mdbContainer'>
              <MDBContainer >
                <MDBIframe src={arquivoFaturamento} />
              </MDBContainer>
            </div>
            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">


                <button onClick={() => setShowModalFaturamento(false)}> Sair </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>


      {(data.length === 0) ? (
        <div>{props.searched ? 'Registro(s) não encontrado(s)!' : ''}</div>
      ) : (
        <Paper className={classes.root}>
          <TableContainer className={props.dense ? classes.containerDense : classes.container}>
            <Table aria-label="a dense table" size={"small"}>
              <TableHead>
                <TableRow style={{ padding: '1px' }}>
                  {((props.mostraCheck == 'S') || (props.regName == 'printCartoes')) ? (
                    <StyledTableCell >

                      <FrCheckBox
                        style={{ padding: '1px' }}
                        indeterminate={selected.length > 0 && selected.length < data.length}
                        checked={data.length > 0 && selected.length === data.length}
                        onChange={handleSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                      />
                    </StyledTableCell>) : (<></>)}

                  {props.detail ? <StyledTableCell style={{ minWidth: 30, width: 30 }} /> : (<></>)}
                  {((!props.readOnly) || (props.regName == 'cobranca')) || props.modal ? (
                    <StyledTableCell
                      style={{ minWidth: width, width: width }}
                    >
                      Opções
                    </StyledTableCell>) : (<></>)}
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ width: column.minWidth, minWidth: column.minWidth }}
                    >
                      <StyledTableSortLabel
                        // className='labelOrder'
                        active={column.order ? (orderBy === column.order) : (orderBy === column.id)}

                        direction={column.order ? (orderBy === column.order ? order : 'asc') : (orderBy === column.id ? order : 'asc')}

                        onClick={createSortHandler((column.order) ? column.order : column.id)}
                      >
                        {column.label}
                      </StyledTableSortLabel>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody >
                {stableSort(data, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                  const isItemSelected = isSelected(row[props.codeName]);
                  const isItemOpened = isOpened(row[props.codeName]);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  if (props.detail) {

                    return (
                      <>
                        <TableRow style={{ padding: '1px' }} aria-checked={isItemSelected} hover role="checkbox" tabIndex={-1} key={row[props.codeName]} selected={isItemSelected}>
                          {(props.mostraCheck == 'S') ? (
                            <TableCell onClick={(event) => handleClick(event, row[props.codeName])} >
                              <FrCheckBox
                                style={{ padding: '1px' }}
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': labelId }}
                              />
                            </TableCell>) : (<></>)}
                          <TableCell>
                            <IconButton aria-label="expand row" size="small" onClick={(event) => handleClickDetail(event, row[props.codeName])}>
                              {isItemOpened ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                          </TableCell>
                          {(!props.readOnly) ? ((props.frame) ? (
                            <TableCell>
                              <Icon className="tableEdit" icon={ic_delete} size={16} onClick={(e) => handleDelete(e, row[props.codeName], props.regName)} />
                            </TableCell>
                          ) : (
                            <TableCell>
                              {/* <Link to={"/salute/" + props.regName + "/registro?codigo=" + row[props.codeName]} onClick={(e) => chamaRegistro(e,props.regName,row[props.codeName])}> */}
                              <Icon className="tableEdit" icon={ic_mode_edit} size={16} onClick={(e) => chamaRegistro(e, props.regName, row[props.codeName])} />
                              {/* </Link> */}
                              <Icon className="tableDelete" icon={ic_delete} size={16} onClick={(e) => handleDelete(e, row[props.codeName], props.regName)} />
                            </TableCell>
                          )) : (<></>)}
                          {columns.map((column) => {

                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === 'number' ? column.format(value, row) :
                                  column.date && value ? moment(value.substr(0, 10)).format('DD/MM/YYYY')
                                    :
                                    value}
                              </TableCell>
                            );
                          })}
                        </TableRow>

                        <TableRow>
                          <TableDetail isOpen={isItemOpened} detail={row} />
                        </TableRow>
                      </>
                    );

                  } else {
                    return (
                      <>
                        <TableRow style={{ padding: '1px' }} className={classes.row} onDoubleClick={(event) => { handleClickModal(event, row['nome'], row['pk_cli']) }} onClick={(event) => { if (!props.readOnly) handleClick(event, row[props.codeName]) }} aria-checked={isItemSelected} hover role="checkbox" tabIndex={-1} key={row[props.codeName]} selected={isItemSelected}>
                          {(props.mostraCheck == 'S') || (props.regName == 'printCartoes') ? (

                            <TableCell padding="checkbox" onClick={(event) => handleClick(event, row[props.codeName])} >
                              <FrCheckBox
                                style={{ padding: '1px' }}
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': labelId }}
                              />
                            </TableCell>) : (<></>)}
                          {
                            props.modal &&
                            <TableCell>
                              <Tooltip title="Selecionar">
                                <Link>
                                  <Icon className="tableEdit" icon={externalLink} size={16} onClick={(event) => { handleClickModal(event, row['nome'], row['pk_cli']) }} />

                                </Link>
                              </Tooltip>
                            </TableCell>
                          }

                          {((!props.readOnly) || (props.regName == 'cobranca')) ? (
                            <TableCell >
                              {/* <Tooltip title="Selecionar">
                                  <Link>
                                    <Icon className="tableEdit" icon={externalLink} size={16} onClick={(event) => { handleClickModal(event, row['nome'], row['pk_cli']) }} />

                                  </Link>
                                </Tooltip> */}
                              {(props.regName !== 'cobranca') && (props.regName !== 'debito_conta') && (props.regName !== 'faturamento_empresa') && (props.regName !== 'boletos') ? (

                                <Tooltip title="Editar">
                                  <Link>
                                    <Icon className="tableEdit" icon={ic_mode_edit} size={16} onClick={(e) => chamaRegistro(e, props.regName, row[props.codeName])} />

                                  </Link>
                                </Tooltip>)
                                : (<></>)}



                              {(props.enableDel == 'S') ? (
                                <Tooltip title="Excluir">
                                  <Link>
                                    <Icon className="tableDelete" icon={ic_delete} size={16} onClick={(e) => handleDelete(e, row[props.codeName], props.regName)} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}
                              {(props.baixaCtr) && !row['data_pag'] ? (
                                <Tooltip title="Baixar Título">
                                  <Link>
                                    <Icon className="tableDelete" icon={ic_attach_money} size={16} onClick={() => window.location.href = "/salute/" + props.regName + "/baixa?codigo=" + row[props.codeName]} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.imprimeFatura) ? (
                                <Tooltip title="Imprimir fatura">
                                  <Link>
                                    <Icon className="tableDelete" icon={ic_picture_as_pdf} size={16} onClick={() => imprimeFatura(row['pk_fat'])} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}



                              {(props.baixaNtf) ? (
                                <Tooltip title="Imprimir Nota Fiscal">
                                  <Link>
                                    <Icon className="tableDelete" icon={ic_picture_as_pdf} size={16} onClick={() => baixaNtf(row['pk_fat'], row)} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}
                              {(props.cancelaFatura) ? (
                                <Tooltip title="Imprimir fatura">
                                  <Icon className="tableDelete" icon={blocked} size={16} onClick={() => cancelaFatura(row['pk_fat'])} />

                                </Tooltip>
                              )
                                : (<></>)}
                              {(props.fechaCaixa) && row['fechado'] !== 'S' ? (
                                <Tooltip title="Imprimir fatura">
                                  <Icon className="tableDelete" icon={blocked} size={16} onClick={() => buscaValoresCaixa(row['fk_cta'])} />

                                </Tooltip>
                              )
                                : (<></>)}
                              {(props.enviaFaturaEmail) ? (
                                <Tooltip title="Enviar Fatura">
                                  <Icon className="tableDelete" icon={ic_email} size={16} onClick={() => enviaFatura(row['pk_fat'])} />

                                </Tooltip>
                              )
                                : (<></>)}
                              {(props.baixaPix) && !row['data_pag'] ? (
                                <Tooltip title="Gerar Qr Code Pix">
                                  <Link>
                                    <Icon className="tableDelete" icon={qrcode} size={16} onClick={() => window.location.href = "/salute/" + props.regName + "/baixa?codigo=[" + row[props.codeName] + ']&pix=true'} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}
                              {(props.lancamentos) ? (
                                <Tooltip title="Lançamentos">
                                  <Link>
                                    <Icon className="tableDelete" icon={folderPlus} size={16} onClick={(e) => props.lancamentos(e, row[props.codeName], props.regName)} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.pdf) ? (
                                <Tooltip title={(props.regName == 'clientes') || (props.regName == 'empresas') ? "Contratos" : "Cliente"}>
                                  <Link to={(props.regName == 'clientes') ? props.pdf + row[props.codeName] + '&buscar=true' :
                                    (props.regName == 'empresas') ? props.pdf + row[props.codeName] + '&buscar=true' :
                                      props.pdf + row['fk_cli'] + '&buscar=true'}>
                                    <Icon className="tableDelete" icon={(props.regName == 'clientes') || (props.regName == 'empresas') ? fileText : userTie} size={16} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.historicos) ? (
                                <Tooltip title="Históricos">
                                  <Link>
                                    <Icon className="tableDelete" icon={ic_history} size={16} onClick={(e) => mostraHistorico(e, row[props.codeName], props.regName, row['nome'], row['ctoVigente'], row['fk_cli'])} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.visualizar) ? (

                                <Tooltip title="Editar">
                                  <Link>
                                    <Icon className="tableEdit" icon={eye} size={16} onClick={(e) => chamaRegistro(e, props.regName, row[props.codeName])} />

                                  </Link>
                                </Tooltip>)
                                : (<></>)}

                              {(props.link) ? (
                                <Tooltip title="Link para dados do cartão">
                                  <Link>
                                    <Icon className="tableDelete" icon={creditCard} size={16} onClick={(e) => copiaLink(e, row[props.codeName])} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.cancelarContrato) ? (
                                <Tooltip title="Cancelar Contrato">
                                  <Link>
                                    <Icon className="tableDelete" icon={blocked} size={16} onClick={(e) => cancelarContrato(e, row[props.codeName])} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.ctr) ? (
                                <Tooltip title={"Contas a Receber"}>
                                  <Link to={(props.regName == 'clientes') ? props.ctr + 'fk_cli=' + row[props.codeName] + '&buscar=true' : props.ctr + 'pk_cto=' + row[props.codeName] + '&buscar=true'}>
                                    <Icon className="tableDelete" icon={coinDollar} size={16} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.printCartao) ? (
                                <Tooltip title={"Imprimir Cartões"}>
                                  <Link>
                                    <Icon className="tableDelete" icon={vcard} size={16} onClick={(e) => imprimeCartoes(e, row[props.codeName])} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.trocaTitular) ? (
                                <Tooltip title="Troca de Titular">
                                  <Link>
                                    <Icon className="tableDelete" icon={exchange} size={16} onClick={() => trocaTitularContrato(row)} />
                                  </Link>
                                </Tooltip>
                              )
                                : (<></>)}

                              {(props.renovacao) ? (
                                <Tooltip title={"Renovar Contrato"}>
                                  <Icon className="tableDelete" icon={spinner11} size={16} onClick={(e) => renovaContrato(e, row[props.codeName])} />
                                </Tooltip>
                              )
                                : (<></>)}


                              {(props.debito_conta) ? (
                                <Icon className="tableDelete" icon={fileText} size={16} onClick={(e) => debitoConta(e, row[props.codeName])} />
                              )
                                : (<></>)}

                              {(props.boletos) ? (
                                <Icon className="tableDelete" icon={fileText} size={16} onClick={(e) => boleto(e, row[props.codeName])} />
                              )
                                : (<></>)}

                            </TableCell>
                          ) : (<></>)}

                          {columns.map((column, idx) => {

                            const value = row[column.id];
                            if (column.isLink) {
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  <Link to={"/salute/" + column.linkTo + "?" + column.searchValue + '=' + row[column.searchValue] + '&buscar=true'}>
                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                  </Link>
                                </TableCell>
                              )
                            } else if (column.render) {
                              const inputTypeMap = {
                                'dateInput': () => {
                                  return (
                                    <TableCell width={column.width} key={column.id} align={column.align}
                                      className={row['titular'] !== 'D' ? '' : 'dependente'}
                                    >

                                      <FrDatePicker
                                        value={(row[column.id] || '').split('T')[0]}
                                        name={column.id}
                                        id={column.id + idx}
                                        color="#49573B"
                                        variant="outlined"
                                        size="small"
                                        style={{ width: 190 }}
                                        onChange={(e) => handleChangeTableInput(e, index, row[props.codeName])}
                                      // onChange={handleChangeModalEmpresas}
                                      />
                                    </TableCell>
                                  )
                                }
                              }

                              return inputTypeMap[column.render]()
                            }
                            else {
                              return (
                                <TableCell width={column.width} key={column.id} align={column.align}
                                  className={row['titular'] !== 'D' ? '' : 'dependente'}
                                >
                                  {column.format && typeof value === 'number' ? column.format(value) :
                                    column.cpf && value && row['tipo'] <= 14 ? mCPF(value) :
                                      column.cpf && value && row['tipo'] > 14 ? mCNPJ(value) :
                                        column.cnpj && value ? mCNPJ(value) :
                                          column.date && value ? moment(value.substr(0, 10)).format('DD/MM/YYYY') :
                                            column.icon && ((props.regName == 'contratos') || (props.regName == 'contratos_empresas') || (props.regName == 'notas_fiscais')) ? <Icon style={{ color: row['color'] }} icon={ic_fiber_manual_record} size={16} /> :
                                              column.date && value ? moment(value.substr(0, 10)).format('DD/MM/YYYY')
                                                :
                                                value}
                                </TableCell>
                              );
                            }
                          })}
                        </TableRow>

                      </>
                    );
                  }
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            className="no-print"
          />
        </Paper>
      )
      }
    </ThemeProvider >
  );
}
